import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import Cars24Logo from "./images/cars-logo.svg";
import loadable from "@loadable/component";
import ExclusiveLabel from "./lottie-files/exclusive-label.json";
import { getDateTimeObject } from "../../../utils/helpers/human-readable-date-parser";
import { PRICE_DISCOVERY, PURCHASE_REQUEST_STATUS } from "../../../constants/seller-diy-constants";
import Tick from "./images/tick.svg";

const Lottie = loadable(() => import("react-lottie"), { ssr: true });

const GsAssuredPrice = ({
    children,
    priceExpiryDate,
    priceExpiryInDays = NUMBER.ZERO,
    isGsAssuredPrice = false,
    purchaseRequestStatus,
    showBottomText = true,
    priceDiscovery
}) => {

    const {formattedDay: day = "", month = "" } = getDateTimeObject(priceExpiryDate, true);
    const dateFormatted = `${day} ${month}`;

    const renderDayCount = () => {
        if (priceExpiryInDays === NUMBER.ONE) return <span styleName={"styles.lastDay"}>1 Day Left</span>;
        return <span>{priceExpiryInDays} Days Left</span>;
    };
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: ExclusiveLabel,
        animType: "svg",
        renderer: "svg",
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const getBottomText = () => {
        if (priceExpiryInDays >= NUMBER.ONE) return <p>This exclusive offer will last till <strong>{dateFormatted}</strong></p>;
        return <p>Your offer will expire soon, reach out to your CARS24<br/> consultant for more information</p>;
    };

    return (
        <div styleName={"styles.gsCardWrapper"}>
            <div styleName={"styles.offerCardHeader"}>
                {!!isGsAssuredPrice &&  <div styleName={"styles.lottieWrapper"}>
                    <Lottie width={88} height={38} options={{defaultOptions, animationData: ExclusiveLabel }} />
                </div>}
                <img src={Cars24Logo} alt="cars24 logo"/>
            </div>
            <div styleName={"styles.offerValueWrapper"}>
                <ul>
                    {children}
                </ul>
                { priceDiscovery !== PRICE_DISCOVERY.ACCEPTED && showBottomText && purchaseRequestStatus !== PURCHASE_REQUEST_STATUS.CREATED &&
                    <div styleName={`styles.expireInfo ${priceExpiryInDays >= NUMBER.ONE ? "styles.animation" : "styles.lastDayWrapper"} `}>
                        {getBottomText()}
                        {priceExpiryInDays >= NUMBER.ONE && renderDayCount()}
                    </div>
                }
                { priceDiscovery === PRICE_DISCOVERY.ACCEPTED &&
                    <div styleName={"styles.priceAccepted"}>
                        <img src={Tick} alt="accept" />
                        <p>PRICE ACCEPTED</p>
                    </div>
                }
            </div>

        </div>
    );
};
GsAssuredPrice.propTypes = {
    children: PropTypes.any,
    priceExpiryDate: PropTypes.any,
    priceExpiryInDays: PropTypes.number,
    isGsAssuredPrice: PropTypes.bool,
    purchaseRequestStatus: PropTypes.string,
    showBottomText: PropTypes.bool,
    priceDiscovery: PropTypes.string
};

export default GsAssuredPrice;
